module.exports = "/_next/static/images/jasbir-7a2be62f977fedcd2e34eeb46213f695.png";